export const VOICE_STATES = {
  IDLE: "IDLE",
  WAKE: "WAKE",
  LISTENING: "LISTENING",
  SPEECH_DETECTED: "SPEECH_DETECTED",
  TRANSCRIBING: "TRANSCRIBING",
  THINKING: "THINKING",
  EXECUTING: "EXECUTING",
  RESPONDING: "RESPONDING",
  SPEAKING: "SPEAKING",
  INTERRUPTED: "INTERRUPTED",
  ERROR: "ERROR",
  MUTED: "MUTED",
};

export const WAKE_WORD_MODES = {
  DISABLED: "DISABLED",
  BROWSER: "BROWSER_WAKE_WORD",
  LOCAL: "LOCAL_WAKE_WORD_PROVIDER",
};

const LEGACY_STATE_ALIASES = {
  WAKE_WORD: VOICE_STATES.WAKE,
};

const LEGACY_WAKE_MODE_ALIASES = {
  WAKE_WORD_DISABLED: WAKE_WORD_MODES.DISABLED,
  WAKE_WORD_BROWSER: WAKE_WORD_MODES.BROWSER,
  WAKE_WORD_LOCAL_PROVIDER: WAKE_WORD_MODES.LOCAL,
};

export const normalizeVoiceState = (value) => {
  const key = String(value || VOICE_STATES.IDLE).toUpperCase();
  return LEGACY_STATE_ALIASES[key] || VOICE_STATES[key] || VOICE_STATES.IDLE;
};

export const normalizeWakeWordMode = (value) => {
  const key = String(value || WAKE_WORD_MODES.DISABLED).toUpperCase();
  return LEGACY_WAKE_MODE_ALIASES[key] || WAKE_WORD_MODES[key.replace(/[^A-Z_]/g, "")] || WAKE_WORD_MODES.DISABLED;
};

export const VOICE_STATE_DISPLAY = {
  [VOICE_STATES.IDLE]: "BEREIT",
  [VOICE_STATES.WAKE]: "AION BEREIT",
  [VOICE_STATES.LISTENING]: "HÖRT ZU",
  [VOICE_STATES.SPEECH_DETECTED]: "SPRACHE ERKANNT",
  [VOICE_STATES.TRANSCRIBING]: "VERSTEHT",
  [VOICE_STATES.THINKING]: "DENKT NACH",
  [VOICE_STATES.EXECUTING]: "FÜHRT AUS",
  [VOICE_STATES.RESPONDING]: "ANTWORTET",
  [VOICE_STATES.SPEAKING]: "SPRICHT",
  [VOICE_STATES.INTERRUPTED]: "GESTOPPT",
  [VOICE_STATES.ERROR]: "FEHLER",
  [VOICE_STATES.MUTED]: "STUMM",
};

export const getWakeWordModeLabel = (mode) => {
  const normalized = normalizeWakeWordMode(mode);
  if (normalized === WAKE_WORD_MODES.BROWSER) return "Browser-Weckwort";
  if (normalized === WAKE_WORD_MODES.LOCAL) return "Lokaler Weckwort-Provider";
  return "Aus";
};

export const getVoiceStateCopy = (state, { hasError = false, wakeWord = "AION" } = {}) => {
  const normalized = normalizeVoiceState(state);
  if (hasError || normalized === VOICE_STATES.ERROR) {
    return {
      title: "Etwas hat nicht geklappt.",
      subtitle: "Ich bin gleich wieder bereit.",
    };
  }
  switch (normalized) {
    case VOICE_STATES.WAKE:
      return {
        title: `Sag einfach ${wakeWord}.`,
        subtitle: "Ich warte auf dein Aktivierungswort.",
      };
    case VOICE_STATES.LISTENING:
      return {
        title: "Ich höre zu …",
        subtitle: "Sprich natürlich mit mir.",
      };
    case VOICE_STATES.SPEECH_DETECTED:
      return {
        title: "Ich höre dich …",
        subtitle: "Ich nehme deine Anfrage gerade auf.",
      };
    case VOICE_STATES.TRANSCRIBING:
      return {
        title: "Ich verstehe …",
        subtitle: "Ich wandle deine Stimme in Text um.",
      };
    case VOICE_STATES.THINKING:
      return {
        title: "Ich denke nach …",
        subtitle: "Ich sammle den richtigen Kontext.",
      };
    case VOICE_STATES.EXECUTING:
      return {
        title: "Ich führe es aus …",
        subtitle: "Ich prüfe die Aktion und setze sie um.",
      };
    case VOICE_STATES.RESPONDING:
      return {
        title: "Ich antworte …",
        subtitle: "Ich formuliere die beste Antwort für dich.",
      };
    case VOICE_STATES.SPEAKING:
      return {
        title: "Ich spreche gerade …",
        subtitle: "Du kannst mich jederzeit unterbrechen.",
      };
    case VOICE_STATES.INTERRUPTED:
      return {
        title: "Okay, gestoppt.",
        subtitle: "Sag einfach weiter, wenn du etwas Neues möchtest.",
      };
    case VOICE_STATES.MUTED:
      return {
        title: "Mikrofon ist aus.",
        subtitle: "Du kannst jederzeit wieder auf aktiv schalten.",
      };
    case VOICE_STATES.IDLE:
    default:
      return {
        title: "Was kann ich für dich tun?",
        subtitle: "Sprich mit mir oder tippe deine Anfrage ein.",
      };
  }
};